module.exports = __webpack_public_path__ + "static/media/9.fc88c30b.png";